import React, { useState } from 'react';
import DocsCtx from './docsCtx';

const DocsContext = (props) => {
  const [selectedItemsDocIds, setSelectedItemsDocIds] = useState<number[]>([]);
  const [selectedItemsIds, setSelectedItemsIds] = useState<number[]>([]);
  const [pageView, setPageView] = useState<boolean | null>(null);

  return (
    <DocsCtx.Provider
      value={{
        selectedItemsDocIds: selectedItemsDocIds,
        selectedItemsIds: selectedItemsIds,
        pageView: pageView,
        setSelectedItemsDocIds: setSelectedItemsDocIds,
        setSelectedItemsIds: setSelectedItemsIds,
        setPageView: setPageView,
      }}>
      {props.children}
    </DocsCtx.Provider>
  );
};

export default DocsContext;
